import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchNewsList = createAsyncThunk(
  "fetchNewsList",
  async ({ page, filters, limit }) => {
    const keyword =
      filters && filters.keyword !== undefined ? `${filters.keyword}` : "";
    const company =
      filters && filters.company !== undefined ? `${filters.company}` : "";
    const category =
      filters && filters.category !== undefined ? `${filters.category}` : "";

    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `news/list?page=${page}&limit=${limit}&keyword=${keyword}&company=${company}&categoryId=${category}`,
      config
    );

    return response.data.data;
  }
);

const newsListSlice = createSlice({
  name: "newsList",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchNewsList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchNewsList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchNewsList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default newsListSlice.reducer;
